import { useSelector } from "react-redux";
import { useState, useEffect, useRef } from "react";
import { toastMessage } from "../../utils/toast";
import { useDispatch } from "react-redux";
import { getLocaleValue } from "../../utils";
import Loader from "react-loader-spinner";
import { onMessageListener } from "../../utils/pushNotification";
import { useTranslation } from "react-i18next";
import { checkoutForCorporateCompanyJob } from "../../Redux/Actions/jobs";
import { clearSession } from "../../utils/initiate";
import { getCorporateJobById } from "../../Redux/Actions/jobs";
import { apiWrapWithErrorWithData } from "../../utils/apiWrapper";

const Checkout = ({ history, match }) => {
  const dispatch = useDispatch();
  const [currentItems, setCurrentItems] = useState([]);
  const [currency, setCurrency] = useState("");
  const [totalAmount, setTotalAmount] = useState(0);
  const [errStatus, setErrStatus] = useState(200);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [payURL, setPayURL] = useState("");
  const { jobID } = match.params;
  const [paymentWindow, setPaymentWindow] = useState(null);
  const paymentIntervalRef = useRef(null);
  const timeoutRefs = useRef([]); 
  const { t } = useTranslation();

  const [responseStatus, setResponseStatus] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [goJobButton, setGoJobButton] = useState(false);

  useEffect(() => {
    checkoutForCorporateCompanyJobApi(jobID);
  }, []);

  const checkoutForCorporateCompanyJobApi = async (jobId) => {
    setLoading(true);
    try {
      const response = await checkoutForCorporateCompanyJob(jobId);
      if (response?.data) {
        setResponseStatus(true);
        setPayURL(response.data?.paymentLink);
        setTotalAmount(response.data?.totalAmount);
        setCurrency(response.data?.currency);
        let summary = response.data?.summary;
        let summaryData = summary.map(({ amount, description }) => {
          return {
            amount: amount,
            summary: getLocaleValue(description),
          };
        });
        setCurrentItems(summaryData);
      }
    } catch (error) {
      setResponseMessage(error?.response?.data?.message);
      toastMessage("error", `Unable to get the payment link `);
      setButtonLoading(false);
      setLoading(false);
      error?.response?.status === 401 && clearSession(dispatch, history);
    }
    setLoading(false);
  };

  useEffect(() => {
    if(paymentWindow) {
      let paymentInterval = setInterval(getStatus, 1000);
      paymentIntervalRef.current = paymentInterval;
      const timeout1 = setTimeout(() => {
        getGoJobButton();
      }, 10000); 
      timeoutRefs.current.push(timeout1); 
  
      const timeout2 = setTimeout(() => {
        getGoJobButton();
      }, 5 * 60 * 10000); 
      timeoutRefs.current.push(timeout2);
    }
  }, [paymentWindow]);

  useEffect(() => {
    return () => {
      if (paymentIntervalRef.current) {
        clearInterval(paymentIntervalRef.current);
      }
      timeoutRefs.current.forEach(timeout => clearTimeout(timeout));
    };
  }, []);

  onMessageListener()
    .then((payload) => {
      let type = payload.data.type;
      let jobId = payload.data.jobID == "0" ? null : payload.data.jobID;
      if (type == "PAYMENT_SUCCESSFUL") {
        history.push(`/home`);
      } else if (type == "PAYMENT_FAILED") {
        history.push(`/jobs/${jobID}`);
      } else if (type == "PAYMENT_COMPLETE" || type == "PAYMENT_FAILED") {
        history.push(`/jobs/${jobID}`);
      }
    })
    .catch((err) => {
      setErrStatus(err?.response?.status);
    });

  const openPaymentPage = () => {
    setButtonLoading(true);
    const features = { width: '500', height: '500' };
    const tempWindow = window.open(payURL, "", features);
    setPaymentWindow(tempWindow);
  };

  const getStatus = async () => {
    const res = await apiWrapWithErrorWithData(getCorporateJobById(jobID));
    const response = res.data.data.paymentStatus;
    if (response === "Completed") {
      clearInterval(paymentIntervalRef.current);
      if (paymentWindow) {
        paymentWindow.close();
        setPaymentWindow(null);
      }
      toastMessage("success", `Transaction Is Completed`);
      history.push(`/jobs`)
    }
  };

  const getGoJobButton = () => {
    setGoJobButton(true);
  };

  return (
    <>
      {loading ? (
        <div className="d-flex align-items-center justify-content-center h-75vh">
          <Loader
            type="ThreeDots"
            color="#2d207d"
            height={40}
            width={40}
            style={{ textAlign: "center" }}
          />
        </div>
      ) : (
        <div>
          <div style={{ textAlign: "center" }}>
            <div>
              <span
                style={{
                  fontSize: "30px",
                  fontWeight: "500",
                  borderBottom: "5px solid #b71c1c",
                  paddingTop: "1%",
                  display: "inline-block",
                  marginBottom: "2%",
                }}
              >
                {getLocaleValue("checkout_title")}
              </span>
            </div>
          </div>
          <div className="d-flex justify-content-center">
            <div className="col-md-5">
              <div className="card">
                <div className="d-flex mt-2">
                  <div
                    className="col-lg-12 card"
                    style={{ border: "0px solid" }}
                  >
                    {responseStatus ? (
                      <div className="card-body form-group fv-plugins-icon-container mb-0">
                        <div style={{ textAlign: "center" }}>
                          <div>
                            <span
                              className="card-title font-weight-bolder text-dark"
                              style={{ fontSize: "20px" }}
                            >
                              {getLocaleValue("checkout_order_summary")}
                            </span>
                          </div>
                        </div>
                        <div className="mt-1 d-flex flex-wrap">
                          <table
                            className="table tableFreez tablefix table-head-custom table-vertical-center table-head-bg"
                            style={{ marginBottom: "0px" }}
                          >
                            <tbody>
                              {currentItems.map(({ sno, summary, amount }) => {
                                return (
                                  <tr key={sno}>
                                    <td>
                                      <span
                                        className="text-dark-75 font-weight-bolder d-block font-size-lg"
                                        style={{
                                          fontWeight: "500",
                                          fontSize: "20px",
                                        }}
                                      >
                                        {summary}
                                      </span>
                                    </td>
                                    <td></td>

                                    <td>
                                      <span
                                        className="text-dark-75 font-weight-bolder d-block font-size-lg"
                                        style={{
                                          fontWeight: "500",
                                          fontSize: "18px",
                                          width: "100px",
                                        }}
                                      >
                                        {amount} {currency}
                                      </span>
                                    </td>
                                  </tr>
                                );
                              })}
                              <tr>
                                <td>
                                  <span
                                    style={{
                                      fontWeight: "500",
                                      fontSize: "20px",
                                    }}
                                  >
                                    {getLocaleValue("checkout_total")}
                                  </span>
                                </td>
                                <td></td>
                                <td>
                                  <span
                                    style={{
                                      fontWeight: "500",
                                      fontSize: "18px",
                                      width: "100px",
                                    }}
                                  >
                                    {`${totalAmount} ${currency}`}{" "}
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div style={{ display: "flex", justifyContent: "center" }}>
                          <button
                            className="btn btn-primary d-flex align-items-center"
                            disabled={buttonLoading}
                            onClick={openPaymentPage}
                          >
                            <span
                              style={{
                                fontWeight: 500,
                                fontSize: "15px",
                                padding: "5px",
                              }}
                            >
                              {buttonLoading
                                ? getLocaleValue("payment_processing")
                                : getLocaleValue("checkout_btn")}
                            </span>
                            {buttonLoading && (
                              <Loader
                                type="Oval"
                                color="#fff"
                                height={20}
                                width={20}
                                style={{ marginLeft: "10px" }}
                              />
                            )}
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div
                          style={{
                            fontWeight: "500",
                            fontSize: "20px",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          {responseMessage}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <button
                            className="btn btn-primary m-3"
                            onClick={() => history.push(`/home`)}
                          >
                            Go Home
                          </button>
                        </div>
                      </div>
                    )}
                    {goJobButton && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          className="btn btn-primary m-3"
                          onClick={() => history.push(`/jobs`)}
                        >
                          Go Jobs
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Checkout;
